import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseListObservable, FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { Client } from "../../models/client";
import { LocationInfo } from "../../models/locationInfo";
import { NavigationItem } from "../../models/navigationItem";
import { NavItemsDefault } from "../../models/navItemsDefault";
import { Hour } from "../../models/hour";
import { Location } from "@angular/common";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { isNullOrUndefined } from 'util';
import { MapsService } from '../../providers/maps.service';
import { CacheMiddlewareService } from "../../providers/cache-middleware.service";
import { MdSlideToggleChange } from '@angular/material';
import { States } from '../../models/states';
import { HubspotLocationOnboarding } from 'ng2/app/models/hubspot-location-from-onboarding';
import { Email } from 'ng2/app/models/email';
import { TypeformLocationOnboarding } from '../../models/typeform-location-from-onboarding';
import * as _ from 'lodash';
import { LeaseVariables } from '../../models/lease-variables';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AWSConnectorService } from '../../providers/aws-connector';

interface IStats {
  current_month_of_payments?: number;
  current_month_payment_amount?: number;
  current_month_rentals?: number;
  current_month_renting_payments?: number;
  current_month_reservations?: number;
  last_month_of_payments?: number;
  last_month_payment_amount?: number;
  last_month_rentals?: number;
  last_month_renting_payments?: number;
  last_month_reservations?: number;
  total_of_payments?: number;
  total_payment_amount?: number;
  total_rentals?: number;
  total_renting_payments?: number;
  total_reservations?: number;
};

@Component({
  selector: 'app-view-client',
  templateUrl: './view-client.component.html',
  styleUrls: ['./view-client.component.css']
})
export class ViewClientComponent implements OnInit, OnDestroy, AfterViewInit {
  key: string;
  client: FirebaseObjectObservable<Client>;
  clientData: Client;
  states = States;

  selectedLocation: LocationInfo;
  location: LocationInfo;
  oldLocationInfo: LocationInfo;
  displayLocationDialog: boolean;
  displayOnboardingDialog: boolean;
  onboardingLocations = [];
  removeListener;

  isNewLocation: boolean;

  sitelinkCredsValid: boolean = null;

  officeHours: FirebaseListObservable<Array<Hour>>;
  gateHours: FirebaseListObservable<Array<Hour>>;
  navItems: FirebaseListObservable<Array<NavigationItem>>;

  locations: any;
  path: string;

  unitsRented: number = 0;
  unitsRentedPayments: number = 0;
  unitsReserved: number = 0;
  payments: any = 0;
  numPayments: any = 0;

  stats: IStats;

  showSpinner = false;

  error: string;

  navItemsGenerated = false;
  onboardingLocationKeyIsDuplicate: boolean = false;
  onboardingLocationKeyIsEmpty: boolean = false;

  infoBarStyleOptions = [
    { label: 'Original Info Bar', value: 'original' },
    { label: 'Phone Right (no portal or email)', value: 'phoneRight' },
    // {label: 'Hide', value: 'none'}
  ];

  locationBarStyleOptions = [
    { label: 'Original Location Bar', value: 'original' },
    // {label: 'Phone Right (no email)', value: 'phoneRight'},
    // {label: 'Hide', value: 'none'}
  ];

  navBarOptions = [
    { label: 'Above Main Nav', value: 'top' },
    { label: 'Below Main Nav', value: 'bottom' },
    { label: 'Hide', value: 'none' }
  ];

  locationsDropdown = [
    { label: 'None', value: '' }
  ];

  countryDropdown = [
    { label: 'Canada', value: 'canada' },
    { label: 'USA (default)', value: 'usa' },
  ];

  homepageComponentsAll = [
    { name: 'Button Component (w/ pic)', value: 'button-component' },
    { name: 'Custom HTML Banner', value: 'html-row-container' },
    { name: 'Facility Info Banner', value: 'facility-info-banner' },
    { name: 'Features Component', value: 'features' },
    { name: 'Google Map', value: 'map-component' },
    { name: 'Location Banner', value: 'location-banner' },
    { name: 'Row of 3 Icons', value: 'row-of-3-icons' },
    { name: 'Reviews', value: 'reviews' },
    { name: 'Separator Bar', value: 'seperator' },
    { name: 'Portable Quote Bar', value: 'portable-quote-bar' },
    { name: 'Uhaul Dealer Banner', value: 'uhaul-dealer-banner' },
    { name: 'Recent Blog Banner', value: 'recent-blogs' },
    { name: 'Homepage Links Card', value: 'pug-homepage-links-card' },
    { name: 'Locations Near You Banner', value: 'locations-near-you-banner' },
    { name: 'View Units', value: 'units' },
    { name: 'Slideshow Row', value: 'pug-slideshow-row' },
    { name: 'HowTo Row', value: 'howto-row' },
    { name: 'Picture Card', value: 'picture-card' },

  ];

  locationHomepageComponentsAll = [
    { name: 'Button Component (w/ pic)', value: 'button-component' },
    { name: 'Custom HTML Banner', value: 'html-row-container' },
    { name: 'Features Component', value: 'features' },
    { name: 'Google Map', value: 'map-component' },
    { name: 'Row of 3 Icons', value: 'row-of-3-icons' },
    { name: 'Reviews', value: 'reviews' },
    { name: 'Portable Quote Bar', value: 'portable-quote-bar' },
    { name: 'Uhaul Dealer Banner', value: 'uhaul-dealer-banner' },
    { name: 'Separator Bar', value: 'separator' },
    { name: 'Hero', value: 'hero' },
    { name: 'View Units', value: 'units' },
    { name: 'Picture Card', value: 'picture-card' },
  ];

  options = {
    key: environment.froalaKey,
    placeholderText: 'Announcement Banner Text',
    charCounterCount: true,
    htmlAllowedEmptyTags: ['div', 'textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.mdi'],
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlRemoveTags: [],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  }

  homepageComponentsLeft = this.homepageComponentsAll;
  homepageComponentsRight = [];
  deleteArray = [];

  locationHomepageComponentsLeft = this.locationHomepageComponentsAll;
  locationHomepageComponentsRight = [];
  locationComponentDeleteArray = [];

  private _dragulaSub: Subscription;

  constructor(
    public afService: FirebaseService,
    private route: ActivatedRoute,
    public cacheMw: CacheMiddlewareService,
    public locationAngular: Location,
    private mapsService: MapsService,
    private renderer: Renderer2,
    private router: Router,
    private dragulaService: DragulaService,
    private awsConn: AWSConnectorService
  ) {
    this.dragulaService.setOptions('dropdown-bag', {
      copy: (el, source) => {
        return source.id === 'left';
      },
      accepts: (el, target, source, sibling) => {
        // To avoid dragging from right to left container
        return target.id !== 'left';
      }
    });
    this.dragulaService.setOptions('location-dropdown-bag', {
      copy: (el, source) => {
        return source.id === 'location-left';
      },
      accepts: (el, target, source, sibling) => {
        // To avoid dragging from right to left container
        return target.id !== 'location-left';
      }
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.cacheMw.selectedClientKey = this.key;

      // this.client = this.afService.getClientInfo(this.key);
      // @ts-ignore
      this.navItems = this.afService.getFacilityNavItems(this.key)
        .map((items: any[]) => items.filter(item => item.$key !== 'noDropdown'))
        .filter(items => items && items.length > 0);
      this.path = '/facilities/' + this.key;
      this.officeHours = this.afService.getMainOfficeHours(this.key);
      this.gateHours = this.afService.getMainGateHours(this.key);
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        if (isNullOrUndefined(this.clientData.homepageComponentsOrder)) {
          this.clientData.homepageComponentsOrder = [];
        }
        if (isNullOrUndefined(this.clientData.locationHomepageComponentsOrder)) {
          this.clientData.locationHomepageComponentsOrder = [];
        }
        console.log(this.clientData.code)

        this.afService.getFacilityStats(this.clientData.$key).then((facilityStats) => {
          this.stats = facilityStats;
        });

        if (isNullOrUndefined(this.clientData.cacheExpireSeconds)) {
          this.clientData.cacheExpireSeconds = 1;
          this.updateClient();
        }
        if (isNullOrUndefined(this.clientData.infoBarStyle)) {
          this.clientData.infoBarStyle = 'original';
          this.updateClient();
        }
        if (isNullOrUndefined(this.clientData.autoPayTerms)) {

          this.clientData.autoPayTerms = `I (We) authorize ${ this.clientData.name } to charge any amounts due per the terms of the agreement for each period during the term of occupancy or until I(we) cancel this authorization.`;
          this.updateClient();
        }
        if (isNullOrUndefined(this.clientData.locationBarStyle)) {
          this.clientData.locationBarStyle = 'original';
          this.updateClient();
        }
        if (isNullOrUndefined(this.clientData.defaultLocationKey)) {
          this.clientData.defaultLocationKey = '';
          this.updateClient();
        }

        if (isNullOrUndefined(this.clientData.showSocialLinks)) {
          this.clientData.showSocialLinks = false;
          this.updateClient();
        }

        // we don't need to update with an empty array
        if (isNullOrUndefined(this.clientData.socialLinks))
          this.clientData.socialLinks = [];

        if (isNullOrUndefined(this.clientData.fontUrls)) {
          this.clientData.fontUrls = [];

          if (!isNullOrUndefined(this.clientData.fontUrl)) {
            this.clientData.fontUrls.push(this.clientData.fontUrl);
          }
          else {
            this.clientData.fontUrls.push('https://fonts.googleapis.com/css?family=Montserrat:400,500,700');
          }
          this.updateClient();
        }

        this.locations = this.afService.getLocations(this.clientData);

        this.afService.getLocations(this.clientData).subscribe((locations) => {
          this.locationsDropdown = [
            { label: 'None', value: '' }
          ];
          this.cacheMw.locationKeys = [];

          for (let location of locations) {
            this.locationsDropdown.push({ label: location.name, value: location.$key });
            this.cacheMw.locationKeys.push(location.$key);
          }

          if (isNullOrUndefined(this.clientData.locationsOrder)) {
            this.clientData.locationsOrder = this.cacheMw.locationKeys;
          }
        });

        this.afService.getFacilityNavItems(this.key).subscribe((data) => {
          if (data.length == 0 && !this.navItemsGenerated) {
            this.navItemsGenerated = true;
            var defaultNavItems = new NavItemsDefault();
            for (let item of defaultNavItems.items) {
              this.afService.saveNavItem(this.clientData, item);
            }
          }
        });
      });
    });

    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.afService.updateSettingsOnServer(this.clientData);
      }
    });
    this._dragulaSub = this.dragulaService.dropModel.subscribe(domStuff => this.updateClient());
  }

  ngAfterViewInit() {
    // this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.error = '';
    this.removeListener();
    try {
      if (this.dragulaService) {
        this.dragulaService.destroy('dropdown-bag');
        this.dragulaService.destroy('location-dropdown-bag');
      }
      if (this._dragulaSub && !this._dragulaSub.closed) {
        this._dragulaSub.unsubscribe();
      }
    }
    catch (err) {
      console.warn('ngOnDestroy error caught:', err);
    }
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  deleteComponent(e) {
    console.log(this.homepageComponentsRight)
    console.log(e)
    console.log(this.clientData.homepageComponentsOrder.indexOf(e.dragData))
    if (this.clientData.homepageComponentsOrder.indexOf(e.dragData) != -1) {
      this.clientData.homepageComponentsOrder.splice(this.clientData.homepageComponentsOrder.indexOf(e.dragData), 1);
    }
    this.updateClient();
  }
  deleteLocationComponent(e) {
    console.log(this.locationHomepageComponentsRight)
    console.log(e)
    console.log(this.clientData.locationHomepageComponentsOrder.indexOf(e.dragData))
    if (this.clientData.locationHomepageComponentsOrder.indexOf(e.dragData) != -1) {
      this.clientData.locationHomepageComponentsOrder.splice(this.clientData.locationHomepageComponentsOrder.indexOf(e.dragData), 1);
    }
    this.updateClient();
  }

  changeComponentOrder(e, type) {
    if (this.clientData.homepageComponentsOrder.indexOf(e.dragData) == -1) {
      this.clientData.homepageComponentsOrder.push(e.dragData);
    }
    this.updateClient();
  }
  changeLocationComponentOrder(e, type) {
    if (this.clientData.locationHomepageComponentsOrder.indexOf(e.dragData) == -1) {
      this.clientData.locationHomepageComponentsOrder.push(e.dragData);
    }
    this.updateClient();
  }

  updateClient() {
    return this.afService.updateClient(this.clientData).then((data) => {
      this.afService.openSnackBar('Sitelink Data successfully saved.');
    });
  }

  updateUhaulImages(e) {
    console.log(e);
  }

  updateUseFaviconToggle(event: MdSlideToggleChange) {
    this.clientData.useFavicon = event.checked;
    this.updateClient();
  }

  updateShowAnnouncement(event: MdSlideToggleChange) {
    this.clientData.showAnnouncement = event.checked;
    this.updateClient();
  }

  updateUseGeoLocation(event: MdSlideToggleChange) {
    this.clientData.useGeolocation = event.checked;
    this.updateClient();
  }

  updateChangeLocationOrder(event: MdSlideToggleChange) {
    this.clientData.changeLocationOrder = event.checked;
    this.updateClient();
  }

  updateChangeHomePageOrder(event: MdSlideToggleChange) {
    this.clientData.changeHomePageOrder = event.checked;
    this.updateClient();
  }
  updateChangeLocationHomePageOrder(event: MdSlideToggleChange) {
    this.clientData.changeLocationHomePageOrder = event.checked;
    this.updateClient();
  }

  updateUseSms(event: MdSlideToggleChange) {
    this.clientData.useSms = event.checked;
    this.updateClient();
  }

  updateShowSocialLinks(event: MdSlideToggleChange) {
    this.clientData.showSocialLinks = event.checked;
    this.updateClient();
  }

  updateclearOutSelectedLocationWhenNavigatingHome(event: MdSlideToggleChange) {
    this.clientData.clearOutSelectedLocationWhenNavigatingHome = event.checked;
    this.updateClient();
  }

  updateGoToLocationHomeOnLogoClick(event: MdSlideToggleChange) {
    this.clientData.goToLocationHomeOnLogoClick = event.checked;
    this.updateClient();
  }

  updateUseCorporateHomeLink(event: MdSlideToggleChange) {
    this.clientData.useCorporateHomeLink = event.checked;
    this.updateClient();
  }

  updatePortableMode(event: MdSlideToggleChange) {
    this.clientData.portableMode = event.checked;
    this.updateClient();
  }

  updateShowLocationNameInsteadOfClientName(event: MdSlideToggleChange) {
    this.clientData.showLocationNameInsteadOfClientName = event.checked;
    this.updateClient();
  }

  updateUseCorporateContactInfo(event: MdSlideToggleChange) {
    this.clientData.useCorporateContactInfo = event.checked;
    this.updateClient();
  }

  updateUseCorporateContactPage(event: MdSlideToggleChange) {
    this.clientData.useCorporateContactPage = event.checked;
    this.updateClient();
  }

  updateAbbreviateStates(event: MdSlideToggleChange) {
    this.clientData.abbreviateStates = event.checked;
    this.updateClient();
  }

  removeSocialLink(index: number) {
    this.clientData.socialLinks.splice(index, 1);
    this.updateClient();
  }

  removeFontUrl(index: number) {
    this.clientData.fontUrls.splice(index, 1);
    this.updateClient();
  }

  onLocationRowSelect(event) {
    this.location = event.data;
    this.oldLocationInfo = _.cloneDeep(this.location);
    this.displayLocationDialog = true;
    this.isNewLocation = false;
  }

  showLocationDialogToAdd() {
    this.location = new LocationInfo();
    this.displayLocationDialog = true;
    this.isNewLocation = true;
  }

  checkLocationKeyDuplicate(loc) {
    return new Promise<boolean>((resolve) => {
      this.locations.subscribe(locs => {
        console.log("🚀 ~ file: view-client.component.ts ~ line 486 ~ ViewClientComponent ~ returnnewPromise ~ locs", locs)
        if (locs && locs.length > 0) {
          const isDup = locs.map(l => l.key).includes(loc.locationKey)
          console.log("🚀 ~ file: view-client.component.ts ~ line 488 ~ ViewClientComponent ~ checkLocationKeyDuplicate ~ isDup", isDup)
          resolve(isDup)
        }
        else {
          resolve(false)
        }
      })
    });
  }

  async newLocationFromOnboarding(data, isTypeform?: boolean) {
    this.showSpinner = true;
    this.isNewLocation = true;
    this.onboardingLocationKeyIsDuplicate = false;
    this.onboardingLocationKeyIsEmpty = false;
    this.oldLocationInfo = null;


    if (!data.locationKey || data.locationKey === "") {
      this.onboardingLocationKeyIsEmpty = true;
      this.showSpinner = false;
      return
    }
    else {
      this.onboardingLocationKeyIsDuplicate = await this.checkLocationKeyDuplicate(data)
      if (this.onboardingLocationKeyIsDuplicate) {
        this.showSpinner = false;
        return
      }
      this.onboardingLocationKeyIsDuplicate = false;
      this.onboardingLocationKeyIsEmpty = false;
      if (isTypeform) {
        this.newLocationFromOnboardingTypeform(data);
      }
      else {
        this.newLocationFromOnboardingHubspot(data);
      }
    }
  }

  newLocationFromOnboardingTypeform(data: TypeformLocationOnboarding) {
    this.location = new LocationInfo();
    console.log(data)
    if (data.isSitelinkReady && !!data.sitelinkCorpCode && !!data.sitelinkLocationCode) {
      if (this.location.siteLinkCorpCode) {
        this.location.siteLinkCorpCode = data.sitelinkCorpCode.toUpperCase();
      }
      if (this.location.siteLinkLocationCode) {
        this.location.siteLinkLocationCode = data.sitelinkLocationCode;
      }
      this.location.siteLinkLicenseKey = 'STORAGEPUG4T67WJN34F';
      this.location.siteLinkCorpUsername = `${ data.sitelinkUserName }:::STORAGEPUG4T67WJN34F`;
      this.location.siteLinkLocationPw = data.sitelinkPassword;
    }
    else {
      this.fillSitelinkDemoDetails();
    }
    this.location.onboardingName = data.fullName;
    this.location.onboardingHours = data.hours;
    this.location.onboardingAccessHours = data.accessHours;
    this.location.onboardingKey = data.origKey;
    this.location.name = data.locationName;
    this.location.tagLine = data.tagline;
    this.location.managersName = data.managersName;
    this.location.numUnits = data.numUnits;
    this.location.occupancyRate = data.occupancyRate;
    this.location.email = data.email;
    this.location.phone = data.phone;
    this.location.address = data.address1;
    this.location.address2 = data.address2;
    this.location.onboardingSitelinkCorpCode = data.sitelinkCorpCode || '';
    this.location.onboardingSitelinkLocationCode = data.sitelinkLocationCode || '';
    this.location.onboardingSitelinkUsername = data.sitelinkUserName || '';
    this.location.onboardingSitelinkPassword = data.sitelinkPassword || '';
    this.location.showSocialLinks = data.showSocialLinks;
    this.location.showInsuranceOptions = data.isInsurance;
    this.location.requireInsurance = data.isInsuranceRequired;
    this.location.showReserveUnitsOption = data.isEnableReservations;
    if (data.isReservationsDaysInAdvance) {
      this.location.daysAReservationCanBeMadeInAdvance = data.reservationsDaysInAdvance;
    }
    this.location.hideRentals = !data.isEnableRentals;
    if (data.isRentalsDaysInAdvance) {
      this.location.daysARentalCanBeMadeInAdvance = data.rentalsDaysInAdvance;
    }
    this.location.onboardingFeatures = data.features;
    this.location.onboardingAdditionalFeatures = data.additionalFeatures;
    this.location.onboardingStorageTypes = data.storageTypes;

    if (data.additionalEmails) {
      this.location.onboardingAdditionalEmails = [];
      _.each(
        _.filter(data.additionalEmails.split(','), e => this._validateEmail(e)),
        email => this.location.onboardingAdditionalEmails.push(new Email(email))
      );
    }

    if (data.isFb) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Facebook.png"
      });
    }
    if (data.isTwitter) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Twitter.png"
      });
    }
    if (data.isYelp) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Yelp.png"
      });
    }
    if (data.isGoogle) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Google%20Plus.png"
      });
    }
    if (data.isInsta) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Instagram.png"
      });
    }
    if (data.isLinkedIn) {
      this.location.socialLinks.push({
        url: '',
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/LinkedIn.png"
      });
    }
    this.location.imageUrl = "https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Demo/tmp-location.jpeg";
    this.location.imageAlt = this.clientData.name + " - " + this.location.name + " Image";
    this.location.imageTitle = this.clientData.name + " - " + this.location.name + " Image";

    this.mapsService.getLatLong(this.location).toPromise().then(([mapsResponse, location]) => {
      this.location.latitude = mapsResponse.results[0].geometry.location.lat;
      this.location.longitude = mapsResponse.results[0].geometry.location.lng;
      this.saveLocation(true, data, data.locationKey);
    });
  }

  newLocationFromOnboardingHubspot(data: HubspotLocationOnboarding) {
    this.location = new LocationInfo();
    this.fillSitelinkDemoDetails();
    this.location.onboardingName = data.firstName + " " + data.lastName;
    this.location.onboardingHours = data.hours;
    this.location.onboardingKey = data.origKey;
    this.location.name = data.locationName;
    this.location.tagLine = data.tagline;
    this.location.managersName = data.managersName;
    this.location.numUnits = data.numUnits;
    this.location.occupancyRate = data.occupancyRate;
    this.location.email = data.email;
    this.location.phone = data.phone;
    this.location.address = data.address1;
    this.location.address2 = data.address2;
    this.location.onboardingSitelinkCorpCode = data.sitelinkCorpCode;
    this.location.onboardingSitelinkLocationCode = data.sitelinkLocationCode;
    this.location.showSocialLinks = data.showSocialLinks;
    if (data.isFb) {
      this.location.socialLinks.push({
        url: data.fbUrl,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Facebook.png"
      });
    }
    if (data.isTwitter) {
      this.location.socialLinks.push({
        url: data.twitterUrl,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Twitter.png"
      });
    }
    if (data.isYelp) {
      this.location.socialLinks.push({
        url: data.yelpUrl,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Yelp.png"
      });
    }
    if (data.isGoogle) {
      this.location.socialLinks.push({
        url: data.google,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Google%20Plus.png"
      });
    }
    if (data.isInsta) {
      this.location.socialLinks.push({
        url: data.insta,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Instagram.png"
      });
    }
    if (data.isLinkedIn) {
      this.location.socialLinks.push({
        url: data.linkedIn,
        iconUrl: "https://cdn.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/LinkedIn.png"
      });
    }
    if (data.isOther) {
      this.location.otherSocial = data.otherSocial;
    }
    this.location.imageUrl = "https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Demo/tmp-location.jpeg";
    this.location.imageAlt = this.clientData.name + " - " + this.location.name + " Image";
    this.location.imageTitle = this.clientData.name + " - " + this.location.name + " Image";

    this.mapsService.getLatLong(this.location).toPromise().then(([mapsResponse, location]) => {
      this.location.latitude = mapsResponse.results[0].geometry.location.lat;
      this.location.longitude = mapsResponse.results[0].geometry.location.lng;
      this.saveLocation(true, data);
    });
  }

  showAddFromOnboardingDialog() {
    this.displayOnboardingDialog = true;
    let sub = this.afService.getOnboardingSubmissions().subscribe((data) => {
      this.onboardingLocations = [];
      let count = 0;
      for (let loc of data) {
        if (loc.is_typeform) {
          this.onboardingLocations.push(new TypeformLocationOnboarding(loc, 'onboarding-' + count, loc.$key));
        }
        else {
          this.onboardingLocations.push(new HubspotLocationOnboarding(loc.properties, 'onboarding-' + count, loc.$key));
        }
        count++;
      }
      sub.unsubscribe();
    });
  }

  async removeLocation() {
    if (confirm(`Are you sure you want to delete ${ this.selectedLocation.name }?`)) {
      this.showSpinner = true;
      try {
        if (this.clientData.locationsOrder) {
          this.clientData.locationsOrder.splice(
            this.clientData.locationsOrder.indexOf(this.selectedLocation.$key),
            1
          );
        }
        if (this.clientData.locationsGroups) {
          const index = _.findIndex(this.clientData.locationsGroups, g => _.indexOf(g.locationKeys, this.selectedLocation.$key) > -1);
          if (index > -1) {
            _.remove(this.clientData.locationsGroups[index].locationKeys, k => k === this.selectedLocation.$key);
          }
        }
        await this.updateClient();
      }
      catch (error) {
        console.log('error deleting location from locations order:', error)
        this.afService.openSnackBar(error.message, 'ERROR!', 5000);
      }
      try {
        await this.afService.deleteLocation(this.clientData, this.selectedLocation);
      }
      catch (error) {
        console.log('error deleting location:', error)
        this.afService.openSnackBar(error.message, 'ERROR!', 5000);
      }
      try {
        await this.afService.deleteEmailsByLocation(this.clientData, this.selectedLocation);
      }
      catch (error) {
        console.log('error deleting location emails:', error)
        this.afService.openSnackBar(error.message, 'ERROR!', 5000);
      }
      try {
        await this.afService.deleteLocationReviewsFromClient(this.clientData, this.selectedLocation);
      }
      catch (error) {
        console.log('error deleting location reviews from client:', error)
        this.afService.openSnackBar(error.message, 'ERROR!', 5000);
      }
      try {
        _.remove(this.clientData.components.maps.markers, m => m.locationKey === this.selectedLocation.$key);
        await this.updateClient();
      }
      catch (error) {
        console.log('error deleting location map marker:', error)
        this.afService.openSnackBar(error.message, 'ERROR!', 5000);
      }

      this.selectedLocation = null;
      this.displayLocationDialog = false;
      this.showSpinner = false;
      this.afService.openSnackBar('Location deleted.');
    }
  }

  getLatLong() {
    this.mapsService.getLatLong(this.location).toPromise().then(([mapsResponse, location]) => {
      this.location.latitude = mapsResponse.results[0].geometry.location.lat;
      this.location.longitude = mapsResponse.results[0].geometry.location.lng;
    });
  }

  fillSitelinkDemoDetails() {
    this.location.siteLinkCorpCode = 'CCTST';
    this.location.siteLinkLocationCode = 'Demo3';
    this.location.siteLinkLicenseKey = 'STORAGEPUG4T67WJN34F';
    this.location.siteLinkCorpUsername = 'Administrator:::STORAGEPUG4T67WJN34F';
    this.location.siteLinkLocationPw = 'Demo';
  }

  verifySitelinkCreds() {
    this.awsConn.verifySitelinkCreds(this.location.siteLinkCorpCode, this.location.siteLinkLocationCode, this.location.siteLinkCorpUsername, this.location.siteLinkLocationPw).toPromise()
      .then((data: any) => {
        console.log(data)
        this.sitelinkCredsValid = data.success;
      })
      .catch(e => {
        console.log("🚀 ~ file: view-client.component.ts ~ line 768 ~ ViewClientComponent ~ verifySitelinkCreds ~ e", e)
        this.sitelinkCredsValid = false;
      })
  }

  addEmail(emailDBName, email, locationKey) {
    return this.afService.saveEmailToList(this.clientData, emailDBName, email, locationKey).then(() => {
      this.afService.openSnackBar('Email successfully added.');
    });
  }

  async saveLocation(saveEmails = false, onboardingLocation = null, oboardingLocationKey?: string) {
    if (!this.clientData.locations)
      this.clientData.locations = [];

    // Remove spaces, special chars and make it lowercase

    if (this.isNewLocation == true) {
      var key
      if (oboardingLocationKey) {
        key = oboardingLocationKey.replace(/[^a-zA-Z0-9- ]/g, "");
        key = key.replace(/\s+/g, '-').toLowerCase();
      }
      else {
        key = this.location.name.replace(/[^a-zA-Z0-9- ]/g, "");
        key = key.replace(/\s+/g, '-').toLowerCase();
      }

      if (this.clientData.locationsOrder) {
        this.clientData.locationsOrder.push(key);
      }
      else {
        this.clientData.locationsOrder = [key];
      }
      this.updateClient();

      const devEmail = new Email('dev@storagepug.com', 'dev');
      if (this.location.siteLinkCorpCode == 'CCTST') {
        this.location.isDemo = true;
      }
      else {
        this.location.isDemo = false;
      }
      this.afService.saveLocation(this.clientData, this.location, key).then(async () => {
        if (saveEmails == true) {
          let email = new Email(this.location.email, this.location.managersName);

          await this._addEmailToLocation(email, key);

          if (this.location.onboardingAdditionalEmails && this.location.onboardingAdditionalEmails.length > 0) {
            _.each(this.location.onboardingAdditionalEmails, (emailAddress: Email) => this._addEmailToLocation(emailAddress, key))
          }

          await this.addEmail('rentalConfirmation', devEmail, key);
          await this.addEmail('reservationConfirmation', devEmail, key);
          await this.addEmail('paymentConfirmation', devEmail, key);
          await this.addEmail('contactFormSubmissions', devEmail, key);

          await this.afService.saveLocationEsignInfo(this.clientData, new LeaseVariables(), key);

          this.afService.setOnboardingLocation(this.location.onboardingKey, onboardingLocation, this.clientData.$key, key);
          this.showSpinner = false;
          this.displayOnboardingDialog = false;
        }
        this.afService.openSnackBar('Location successfully created.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }
    else {
      if (this.checkForLocationAddressChange()) {
        try {
          this.location.timezone = await this.mapsService.getTimezoneInfo(this.location);
        } catch (e) {
          console.warn('error caught getting timezone info:', e);
          this.afService.openSnackBar(e.message);
        }
      }
      this.afService.updateLocation(this.clientData, this.location).then(() => {
        this.oldLocationInfo = null;
        this.afService.openSnackBar('Location successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }

    this.displayLocationDialog = false;
  }

  checkForLocationAddressChange() {
    if (this.oldLocationInfo) {
      return (
        this.oldLocationInfo.address !== this.location.address
        || this.oldLocationInfo.address2 !== this.location.address2
        || this.oldLocationInfo.latitude !== this.location.latitude
        || this.oldLocationInfo.longitude !== this.location.longitude
      )
    }

    return false;
  }

  updateEachAndEveryCache() {
    this.error = '';
    this.showSpinner = true;
    this.cacheMw.updateEachAndEveryCache(this.clientData.code, this.clientData.propertySoftware).toPromise().then((data) => {
      this.showSpinner = false;
      if (data === 'success') {
        this.afService.listenForCaches(this.clientData.$key);
        this.afService.openSnackBar('Each and Every Cache Started', 'Close', 3000);
      }
      else {
        this.error = data;
      }
    }, error2 => {
      this.error = error2;
      this.showSpinner = false;
    });
  }

  updateAllUnitsCache() {
    this.error = '';
    this.showSpinner = true;
    this.cacheMw.updateAllUnitsCache(this.clientData.code, this.clientData.propertySoftware).subscribe((data) => {
      this.showSpinner = false;
      if (data['RT'] || data == 'Error' || data == 'Invalid username/password') {
        this.error = 'An error happened and the units cache was not updated. Make sure the API information is correct on the Location.';
      }
      else
        this.afService.openSnackBar('All Units Cache Updated Successfully.');
      console.log(data)
    }, error2 => {
      this.showSpinner = false;
      this.error = error2;
    });
  }

  updateAvailbleUnitsCache() {
    this.error = '';
    this.showSpinner = true;
    this.cacheMw.updateAvailableUnitsCache(this.clientData.code, this.clientData.propertySoftware).subscribe((data) => {
      this.showSpinner = false;
      if (data['RT'] || data == 'Error') {
        this.error = 'An error happened and the units cache was not updated. Make sure the API information is correct on the Location.';
      }
      else
        this.afService.openSnackBar('All Available Units Cache Updated Successfully.');

      console.log(data)
    }, error2 => {
      this.showSpinner = false;
      this.error = error2;
    });

  }

  updateDiscountsCache() {
    this.error = '';
    this.showSpinner = true;

    this.cacheMw.updateDiscountsCache(this.clientData.code, this.clientData.propertySoftware).subscribe((data) => {
      this.showSpinner = false;
      if (data['RT'] || data == 'Error') {
        this.error = 'An error happened and the units cache was not updated. Make sure the API information is correct on the Location.';
      }
      else
        this.afService.openSnackBar('All Discounts Cache Updated Successfully.');

      console.log(data)
    }, error2 => {
      this.showSpinner = false;
      this.error = error2;
    });
  }

  updateInsuranceCache() {
    this.error = '';
    this.showSpinner = true;
    this.cacheMw.updateInsuranceCache(this.clientData.code, this.clientData.propertySoftware).subscribe((data) => {
      this.showSpinner = false;
      if (data['RT'] || data == 'Error') {
        this.error = 'An error happened and the units cache was not updated. Make sure the API information is correct on the Location.';
      }
      else
        this.afService.openSnackBar('All Insurance Cache Updated Successfully.');
      console.log(data)
    }, error2 => {
      this.showSpinner = false;
      this.error = error2;
    });
  }

  private async _addEmailToLocation(email: Email, key) {
    await this.addEmail('rentalConfirmation', email, key);
    await this.addEmail('reservationConfirmation', email, key);
    await this.addEmail('paymentConfirmation', email, key);
    await this.addEmail('newAccountCreation', email, key);
    await this.addEmail('customerInfoUpdateNotification', email, key);
    await this.addEmail('passwordReset', email, key);
    await this.addEmail('contactFormSubmissions', email, key);
    await this.addEmail('moveOutDateConfirmation', email, key);
    await this.addEmail('changeOfAutoPayConfirmation', email, key);
  }

  private _validateEmail(e) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e)
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/view-client/view-client.component.ts